// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ctg4Z","rootMobile":"styles_rootMobile__3mIwm"};